import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row-12 text-end mb-5" }
const _hoisted_2 = {
  type: "submit",
  class: "btn btn-primary btn-sm",
  ref: "submitButton"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Save", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "row g-xxl-9" }
const _hoisted_9 = { class: "col-xxl-12" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = {
  class: "accordion",
  id: "cancel_accordion"
}
const _hoisted_12 = { class: "accordion-item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "cancel_accordion_header_1"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button fs-6 fw-bold collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#cancel_accordion_body_1",
    "aria-expanded": "false",
    "aria-controls": "cancel_accordion_body_1"
  }, " Cancel Page Details ")
], -1)
const _hoisted_14 = {
  id: "cancel_accordion_body_1",
  class: "accordion-collapse collapse",
  "aria-labelledby": "cancel_accordion_header_1",
  "data-bs-parent": "#cancel_accordion"
}
const _hoisted_15 = { class: "accordion-body" }
const _hoisted_16 = { class: "card-body p-0" }
const _hoisted_17 = { class: "pt-0" }
const _hoisted_18 = { class: "mb-5 fv-row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Cancel Policy Url", -1)
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Enter the url of the product cancellation policy. ", -1)
const _hoisted_23 = { class: "mb-10 fv-row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Cancellation Policy Description", -1)
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = {
  class: "accordion",
  id: "refund_accordion"
}
const _hoisted_28 = { class: "accordion-item" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "refund_accordion_header_1"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button fs-6 fw-bold collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#refund_accordion_body_1",
    "aria-expanded": "true",
    "aria-controls": "refund_accordion_body_1"
  }, " Refund Page Details ")
], -1)
const _hoisted_30 = {
  id: "refund_accordion_body_1",
  class: "accordion-collapse collapse",
  "aria-labelledby": "refund_accordion_header_1",
  "data-bs-parent": "#refund_accordion"
}
const _hoisted_31 = { class: "accordion-body" }
const _hoisted_32 = { class: "card-body p-0" }
const _hoisted_33 = { class: "pt-0" }
const _hoisted_34 = { class: "mb-10 fv-row" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Refund Policy Url", -1)
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Enter the url of the product refund policy. ", -1)
const _hoisted_39 = { class: "mb-10 fv-row" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Refund Policy Description", -1)
const _hoisted_41 = { class: "fv-plugins-message-container" }
const _hoisted_42 = { class: "fv-help-block" }
const _hoisted_43 = { class: "d-flex flex-column" }
const _hoisted_44 = {
  class: "accordion",
  id: "delivery_accordion"
}
const _hoisted_45 = { class: "accordion-item" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "delivery_accordion_header_1"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button fs-6 fw-bold collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#delivery_accordion_body_1",
    "aria-expanded": "true",
    "aria-controls": "delivery_accordion_body_1"
  }, " Delivery Page Details ")
], -1)
const _hoisted_47 = {
  id: "delivery_accordion_body_1",
  class: "accordion-collapse collapse",
  "aria-labelledby": "delivery_accordion_header_1",
  "data-bs-parent": "#delivery_accordion"
}
const _hoisted_48 = { class: "accordion-body" }
const _hoisted_49 = { class: "card-body p-0" }
const _hoisted_50 = { class: "pt-0" }
const _hoisted_51 = { class: "mb-10 fv-row" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Delivery Policy Url", -1)
const _hoisted_53 = { class: "fv-plugins-message-container" }
const _hoisted_54 = { class: "fv-help-block" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Enter the url of the product delivery policy. ", -1)
const _hoisted_56 = { class: "mb-10 fv-row" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Delivery Policy Description", -1)
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = {
  class: "accordion",
  id: "recurring_accordion"
}
const _hoisted_61 = { class: "accordion-item" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "recurring_accordion_header_1"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button fs-6 fw-bold collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#recurring_accordion_body_1",
    "aria-expanded": "true",
    "aria-controls": "recurring_accordion_body_1"
  }, " Recurring Page Details ")
], -1)
const _hoisted_63 = {
  id: "recurring_accordion_body_1",
  class: "accordion-collapse collapse",
  "aria-labelledby": "recurring_accordion_header_1",
  "data-bs-parent": "#recurring_accordion"
}
const _hoisted_64 = { class: "accordion-body" }
const _hoisted_65 = { class: "card-body p-0" }
const _hoisted_66 = { class: "pt-0" }
const _hoisted_67 = { class: "mb-10 fv-row" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Recurring Policy Url", -1)
const _hoisted_69 = { class: "fv-plugins-message-container" }
const _hoisted_70 = { class: "fv-help-block" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, " Enter the url of the recurring policy. ", -1)
const _hoisted_72 = { class: "mb-10 fv-row" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Recurring Policy Description", -1)
const _hoisted_74 = { class: "fv-plugins-message-container" }
const _hoisted_75 = { class: "fv-help-block" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end pt-10" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    novalidate: "novalidate",
    "validation-schema": _ctx.validation,
    onSubmit: _ctx.onSubmit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", _hoisted_2, _hoisted_5, 512)
      ]),
      (_ctx.getIsDataEmpty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_alert, {
                title: "Add Merchant Terms",
                type: "success",
                effect: "light",
                description: "Complete your setup by adding the terms and policies for your products.",
                "show-icon": ""
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "cancel_url",
                            class: "form-control mb-2 fs-7",
                            placeholder: "",
                            modelValue: _ctx.cancelUrl,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cancelUrl) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_ErrorMessage, { name: "cancel_url" })
                            ])
                          ]),
                          _hoisted_22
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.cancelPolicy,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cancelPolicy) = $event)),
                            class: "form-control mb-2 fs-7",
                            rows: 4,
                            type: "text",
                            placeholder: "",
                            as: "textarea",
                            name: "cancel_policy"
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_ErrorMessage, { name: "cancel_policy" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "refund_url",
                            class: "form-control mb-2 fs-7",
                            placeholder: "",
                            modelValue: _ctx.refundUrl,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.refundUrl) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_ErrorMessage, { name: "refund_url" })
                            ])
                          ]),
                          _hoisted_38
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.refundPolicy,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.refundPolicy) = $event)),
                            class: "form-control mb-2 fs-7",
                            rows: 4,
                            type: "text",
                            placeholder: "",
                            as: "textarea",
                            name: "refund_policy"
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createVNode(_component_ErrorMessage, { name: "refund_policy" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _hoisted_52,
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "contact_url",
                            class: "form-control mb-2 fs-7",
                            placeholder: "",
                            modelValue: _ctx.contactUrl,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contactUrl) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _createVNode(_component_ErrorMessage, { name: "contact_url" })
                            ])
                          ]),
                          _hoisted_55
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _hoisted_57,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.deliveryPolicy,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.deliveryPolicy) = $event)),
                            class: "form-control mb-2 fs-7",
                            rows: 4,
                            type: "text",
                            placeholder: "",
                            as: "textarea",
                            name: "delivery_policy"
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                              _createVNode(_component_ErrorMessage, { name: "delivery_policy" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                          _hoisted_68,
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "recurring_url",
                            class: "form-control mb-2 fs-7",
                            placeholder: "",
                            modelValue: _ctx.recurringUrl,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.recurringUrl) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              _createVNode(_component_ErrorMessage, { name: "recurring_url" })
                            ])
                          ]),
                          _hoisted_71
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _hoisted_73,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.recurringPolicy,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.recurringPolicy) = $event)),
                            class: "form-control mb-2 fs-7",
                            rows: "4",
                            type: "text",
                            placeholder: "",
                            name: "recurring_policy",
                            as: "textarea"
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("div", _hoisted_75, [
                              _createVNode(_component_ErrorMessage, { name: "recurring_policy" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _hoisted_76
    ]),
    _: 1
  }, 8, ["validation-schema", "onSubmit"]))
}